if (!customElements.get('airship-portal-menu')) {
  customElements.define('airship-portal-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.toggle = this.querySelector('summary');
      this.panel = this.querySelector('.portal-menu__panel');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const close = () => { this.details.open = false; };
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          event.stopPropagation();
          close();
          this.toggle.focus();
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) close();
      }, options);
      document.addEventListener('focusin', (event) => {
        if (!this.contains(event.target)) close();
      }, options);
      this.details.addEventListener('toggle', () => {
        if (!this.details.open) return;
        document.querySelectorAll('airship-portal-menu').forEach((menu) => {
          if (menu !== this) menu.querySelector('details').open = false;
        });
        // Keep the panel inside the viewport in every header layout.
        this.panel.style.setProperty('--portal-shift', '0px');
        const bounds = this.panel.getBoundingClientRect();
        const shift = bounds.left < 12 ? 12 - bounds.left : Math.min(0, window.innerWidth - 12 - bounds.right);
        this.panel.style.setProperty('--portal-shift', `${shift}px`);
      }, options);
      window.addEventListener('resize', close, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
